import * as React from 'react';
import { BrowserRouter as Router, useLocation } from 'react-router-dom';
import { CssBaseline, Container, Box, ThemeProvider } from '@mui/material';
import theme from './theme/theme';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import AnimatedRoutes from './components/AnimatedRoutes';

// ScrollToTop component
function ScrollToTop() {
  const { pathname } = useLocation();
  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

const App: React.FC = () => {
  return (
    <Router>
      <ScrollToTop />
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            minHeight: '100vh',
          }}
        >
          <Navbar />
          <Box
            component="main"
            sx={{
              flex: '1 0 auto',
              display: 'flex',
              flexDirection: 'column',
            }}
          >
            <Container 
              maxWidth="xxl" 
              sx={{ 
                px: { xs: 2, sm: 3, md: 4, lg: 6 },
                overflow: 'hidden',
                width: '100%',
                '@media (min-width: 2000px)': {
                  maxWidth: '2000px',
                }
              }}
            >
              <AnimatedRoutes />
            </Container>
          </Box>
          <Footer />
        </Box>
      </ThemeProvider>
    </Router>
  );
};

export default App;
